export default function checkboxDropdown() {
  return {
    selection: Array.from(this.$refs.dropdown.querySelectorAll('input[type="checkbox"]:checked')).map(input => input.value),

    submitForm() {
      const form = document.querySelector("#kpi_graph");
      form.requestSubmit();
    },

    submitChange() {
      this.changeSummary();
      this.submitForm();
    },

    clearSelection() {
      if (this.$refs.details.open) {
        this.$nextTick(() => {
          this.$refs.details.open = true;
        });
      }
      const checkboxes = this.$refs.dropdown.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      this.selection = [];
      this.changeSummary();
      this.submitForm();
    },

    changeSummary() {
      if (this.selection.length === 0) {
        this.$refs.all_items.classList.remove('hidden');
        this.$refs.clear_selection.classList.add('hidden');
        this.$refs.item_selection.classList.add('hidden');
      } else if (this.selection.length > 0) {
        this.$refs.all_items.classList.add('hidden');
        this.$refs.clear_selection.classList.remove('hidden');
        this.$refs.item_selection.classList.remove('hidden');
        const re = /\d/
        this.$refs.item_selection.innerHTML = this.$refs.item_selection.innerHTML.replace(re, this.selection.length);
      }
    }
  }
}
